var React = require('react');

function EyeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M43.0001 0.962921C14.4882 0.962921 0.600098 27.5 0.600098 27.5C0.600098 27.5 15.9701 54.0371 43.0001 54.0371C70.0301 54.0371 85.4001 27.5 85.4001 27.5C85.4001 27.5 71.512 0.962921 43.0001 0.962921ZM43.0001 48.4731C31.551 48.4731 22.222 39.0562 22.222 27.4989C22.222 15.9416 31.5508 6.52478 43.0001 6.52478C54.4494 6.52478 63.7782 15.9416 63.7782 27.4989C63.7782 39.0562 54.4494 48.4731 43.0001 48.4731Z","fill":"#409395","key":0}),React.createElement("path",{"d":"M43.0003 18.2959C37.9114 18.2959 33.8826 22.4671 33.8826 27.4996C33.8826 32.6364 38.0149 36.7033 43.0003 36.7033C47.9814 36.7033 52.118 32.532 52.118 27.4996C52.118 22.3627 48.0891 18.2959 43.0003 18.2959Z","fill":"#409395","key":1})]);
}

EyeInline.defaultProps = {"width":"86","height":"55","viewBox":"0 0 86 55","fill":"none"};

module.exports = EyeInline;

EyeInline.default = EyeInline;
